export default "__VITE_ASSET__5c528405__"